module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAABHUlEQVRIx2NgYNhMDFrUZ/f9JgNB9GEW22NFAWIQw6jFoxZjt/jGQYaJxTxnN3DSz+Lb+9nKE4Sfn2GYXiuyul/wzkHm6iTR56eYaW7x1DpedzORNSViU+Ml56RKLMgVc9AX2TiTneYWr+znS/eTPx8ltsBDYKW34IkQqQR3+R3zaG9xbhJvUajSkkSxvf18G9r4VqTI5AYoz2xnpbnFSTE8Sd6y1qV5MXUOHkV+FrnFQIvn9dDe4hkt/PbWgqU9Dokt7sFVvoXN7mmBEtvmcdDc4jUTeQNdeY+0cUxrVl/UJ7Orkqs+hYcecfz0BOODHcxTmzhKIuXLY2QWdbG/PMz06BgjnQqQB0cYW/N5JtZwvzzLOFpWj1o8yCwGAAMajyjdHHhyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/md.png
// module id = 874
// module chunks = 0